import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, Button, Input, Select } from 'antd';
import { isEmpty } from 'utils/utils';
import { useRefCode, useProjectAskDetail } from 'hooks';
import { CompanySelectBox, CrmSelectBox, BusinessPart, LectureType, LectureSubject, HowKnow, Pm } from 'components/atoms'
import { getCodeNumberArray } from 'utils/form-utils';
import CheckDuplicateModal from 'components/molecules/CheckDuplicateModal';
import { fetcher } from 'services';

export interface ProjectAskEditModalProps extends PopupProps {
    id: number;
}

const ProjectAskEditModal = ({ 
    isOpen, 
    onClose,
    id}: ProjectAskEditModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
    const [isFormDone, setIsFormDone] = useState<boolean>(false);
    const [companySrl, setCompanySrl] = useState<number>(0);
    const [companyName, setCompanyName] = useState<string>('');
    const [isCheckConfirm, setIsCheckConfirm] = useState<boolean>(false);
    const [saveData, setSaveData] = useState<ProjectAskSaveReqDto>();

  /* ======================================================
  * hooks
  * ====================================================== */
  const { refCodeList: statusTypeList } = useRefCode({field:'ask_status_type', status_type: 'AV'});  
  const { askInfo, insertSuccess, updateSuccess, askInsert, askUpdate } = useProjectAskDetail(id);

   /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();
  const { TextArea } = Input;
   /* ======================================================
   * events
   * ====================================================== */
    const onCancel = () => {
        onClose?.(false);
    };

    const onSubmit = (e) => {
        const pdata = 
        {
            id: id,
            company_srl: e.company_srl, 
            crm_srl: e.crm_srl,
            business_part: e.business_part,
            is_new: e.is_new,
            how_know: e.how_know,
            how_know_memo: e.how_know_memo,
            lecture_type1: e.lecture_type1,
            lecture_subject1: e.lecture_subject1,
            lecture_subject_memo: e.lecture_subject_memo,
            request_memo: e.request_memo, 
            propose_url: e.propose_url,
            status_type: (id > 0)?e.status_type:'confirm', 
            pm: e.pm, 
            pm2: e.pm2, 
            memo: e.memo,
        }

        setSaveData(pdata);
        if (id > 0) {
            if (askInfo?.status_type !== e.status_type && e.status_type === 'confirm') {
                setIsCheckConfirm(true);
            } else 
                askUpdate(pdata)
        } else {
            askInsert(pdata)
        }
    };

    const onChangeForm = () => { 
        /*
        setIsFormDone(
            !(
                (isEmpty(form.getFieldValue('business_part'))) || 
                Number(form.getFieldValue('company_srl'))<1|| 
                Number(form.getFieldValue('crm_srl'))<1 || 
                (isEmpty(form.getFieldValue('is_new'))) || 
                isEmpty(form.getFieldValue('how_know')) || 
                ((id > 0) && isEmpty(form.getFieldValue('status_type'))) 
            )
        );    
            */
    };      

    const onCheckPopupClick = (isOk: boolean) => {
        if (isOk && saveData) {
            fetcher.project.postProjectInsertFromAsk(saveData)
            .then((res) => {
                switch (res.code) {
                    case 200:
                        askUpdate(saveData)                               
                    break;
                    default:  
                    break;
                };
            });
        }   
        setIsCheckConfirm(false);
    } 

  /* ======================================================
   * effects
   * ====================================================== */
    useEffect(() => {
        if (!!askInfo) {            
            form.setFieldsValue({
                id: askInfo.id,
                company_srl: askInfo.company_srl, 
                crm_srl: askInfo.crm_srl,
                business_part: askInfo.business_part,
                is_new: askInfo.is_new,
                how_know: askInfo.how_know,
                how_know_memo: askInfo.how_know_memo,
                lecture_type1: askInfo.lecture_type1,
                lecture_subject1: askInfo.lecture_subject1,
                lecture_subject_memo: askInfo.lecture_subject_memo,
                request_memo: askInfo.request_memo, 
                propose_url: askInfo.propose_url,
                status_type: askInfo.status_type, 
                pm: getCodeNumberArray(askInfo.pm),
                pm2: getCodeNumberArray(askInfo.pm2),
                memo: askInfo.memo,
            });

            setCompanySrl(askInfo.company_srl);
            setCompanyName(askInfo.company_name);
        }
    }, [askInfo])

    useEffect(() => {
        if (insertSuccess || updateSuccess) {
            onClose?.(true);  
        }
    }, [insertSuccess, updateSuccess])

    return (
    <>
        <ModalWrapper open={isOpen} onCancel={onCancel} width={650} title={id===0?'문의 등록':'문의 수정'} closable>
            <Form
                form={form}
                name="ProjectInfo"
                layout="horizontal"  
                labelCol={{ flex: '120px' }}
                onFieldsChange={onChangeForm}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                <Form.Item name="business_part" label={'사업부서'} rules={[{ required: true, message: '' }]}>
                    <BusinessPart form={form} />
                </Form.Item>    
                <Form.Item name="company_srl" label={'고객사(기업명)'} rules={[{ required: true, message: '' }]}>
                    <CompanySelectBox required={true} form={form} company_srl={companySrl} onSelected={(value, option) => {setCompanySrl(Number(value)); setCompanyName(option.label);}} />
                </Form.Item>  
                <Form.Item name="crm_srl" label={'담당자'} rules={[{ required: true, message: '' }]}>
                    <CrmSelectBox form={form} company={companySrl} company_name={companyName} />                  
                </Form.Item>     
                <Form.Item name="how_know" label={'인지경로'} rules={[{ required: true, message: '' }]}>
                    <HowKnow form={form} />
                </Form.Item>   
                <Form.Item label={'강의 구분'}>
                    <LectureType form={form} />
                </Form.Item>                    
                <Form.Item label={'강의 주제'}>
                    <LectureSubject form={form} />
                </Form.Item>                  
                <Form.Item name='request_memo' label={'요청사항'}>
                    <TextArea rows={3} placeholder='요청사항을 입력하세요'/>   
                </Form.Item>                  
                <Form.Item name='propose_url' label={'제안 경로'}>
                    <Input placeholder='제안 경로 주소를 입력하세요'/>   
                </Form.Item>  
                <Form.Item label={'기본대응'}>
                    <Pm fieldname={'pm'} />   
                </Form.Item>     
                <Form.Item label={'F/U'}>
                    <Pm fieldname={'pm2'} />   
                </Form.Item>                                                       
                <Form.Item name='memo' label={'메모'}>
                    <TextArea rows={3} placeholder='메모를 입력하세요'/>   
                </Form.Item>                                                 
                <ButtonGroup className={'buttonsWrapper'}>
                    <Button onClick={onCancel}>취소</Button>
                    <Button htmlType="submit"  type="primary">{id===0?'등록':'수정'}</Button>
                </ButtonGroup>                
            </Form>            
        </ModalWrapper>  
        <CheckDuplicateModal
            title="프로젝트 확인"
            message={'확정을 하시면 논의중 항목에 해당 프로젝트가 자동으로 생성됩니다. \n상태를 변경 하시겠습니까?'}
            visible={isCheckConfirm}
            onOk={() => onCheckPopupClick(true)}
            onCancel={() => onCheckPopupClick(false)}
        />    
    </>
    )    
};

export default React.memo(ProjectAskEditModal);    